import "bootstrap/dist/css/bootstrap.min.css";
import "react-clock/dist/Clock.css";
import "react-modern-drawer/dist/index.css";
import "react-toastify/dist/ReactToastify.min.css";
import "react-tooltip/dist/react-tooltip.css";
import "./assets/styles/color.css";
import "./assets/styles/style.css";
import "./assets/styles/typography.css";
import "./index.css";

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  allTablesColumnsApiEndPoint,
  allTablesSelectedColumnsApiEndPoint,
  getLoginUserDetailsApiEndPoint,
} from "./apis/apis";
import { setAllPermissions, updateUser } from "./store/auth/authSlice";
import {
  setSelectedSubAdminColumns,
  setSelectedWebUserColumns,
  setSubAdminColumns,
  setWebUserColumns,
} from "./store/common/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import AdminUserListPage from "./pages/AdminUserList";
import BaseProductProductGroupPage from "./pages/WebDataManagement/Mapping/BaseProductProductGroup";
import BeforeLoginRoute from "./utils/BeforeLoginRoute";
import BlogPostsPage from "./pages/BlogManagement/Posts";
import BlogPostsFormPage from "./pages/BlogManagement/Posts/Form";
import BrandsPage from "./pages/WebDataManagement/MasterData/Brands";
import CompetitionGroupCompetitionPage from "./pages/WebDataManagement/Mapping/CompetitionGroupCompetition";
import CompetitionGroupsPage from "./pages/WebDataManagement/MasterData/CompetitionGroups";
import CompetitionsPage from "./pages/WebDataManagement/MasterData/Competitions";
import ConditionsPage from "./pages/WebDataManagement/MasterData/Conditions";
import CountriesPage from "./pages/RegionManagement/Countries";
import CurrenciesPage from "./pages/CurrencyManagement/Currencies";
import DashboardPage from "./pages/DashboardPage";
import EditionsPage from "./pages/WebDataManagement/MasterData/Editions";
import FxRatesPage from "./pages/CurrencyManagement/FxRates";
import GendersPage from "./pages/WebDataManagement/MasterData/Genders";
import { Get } from "./Axios/AxiosFunctions";
import LanguagesPage from "./pages/LanguageManagement/Languages";
import { Loader } from "./components/Loader";
import LoginPage from "./pages/LoginPage";
import MaterialsPage from "./pages/WebDataManagement/MasterData/Materials";
import { PRODUCT_GROUPS } from "./constant/constants";
import ProductBrandPage from "./pages/WebDataManagement/Mapping/ProductBrand";
import ProductCategoriesPage from "./pages/WebDataManagement/MasterData/ProductCategories";
import ProductGenderSizePage from "./pages/WebDataManagement/Mapping/ProductGenderSize";
import ProductGroupsPage from "./pages/WebDataManagement/MasterData/ProductGroups";
import ProductSizesPage from "./pages/WebDataManagement/MasterData/ProductSizes";
import ProductVersionPage from "./pages/WebDataManagement/Mapping/ProductVersion";
import ProductsPage from "./pages/WebDataManagement/MasterData/Products";
import ProtectedRouter from "./utils/ProtectedRoute";
import RoleAndPermissions from "./pages/RoleAndPermissions";
import SportGroupCategoryProductPage from "./pages/WebDataManagement/Mapping/SportGroupCategoryProduct";
import SportsPage from "./pages/WebDataManagement/MasterData/Sports";
import TeamGroupTeamPage from "./pages/WebDataManagement/Mapping/TeamGroupTeam";
import TeamGroupsPage from "./pages/WebDataManagement/MasterData/TeamGroups";
import TeamsPage from "./pages/WebDataManagement/MasterData/Teams/index";
import TermsPage from "./pages/WebDataManagement/MasterData/Terms";
import { ToastContainer } from "react-toastify";
import TransactionsPage from "./pages/TransactionManagement/Transactions";
import TranslationsPage from "./pages/LanguageManagement/Translations";
import VersionsPage from "./pages/WebDataManagement/MasterData/Versions";
import WebUsersPage from "./pages/UserManagement/WebUserListPage";
import WebUserDetailPage from "./pages/UserManagement/WebUserDetailPage";
import BannersPage from "./pages/ContentManagement/Banners";
import BackgroundsPage from "./pages/ContentManagement/Backgrounds";
import PlayersPage from "./pages/Profiles/Players";
import PlayerCareersPage from "./pages/WebDataManagement/Mapping/PlayerCareers";
import AnnouncementsPage from "./pages/ContentManagement/Announcements";
import VideoCategoriesPage from "./pages/JMInteractive/Videos/VideoCategories";
import VideoPostedPage from "./pages/JMInteractive/Videos/VideoPosted";
import EventParticipantsPage from "./pages/Profiles/EventParticipant";
import BlogCategoriesPage from "./pages/BlogManagement/Categories";
import PlayerTypesPage from "./pages/Profiles/PlayerType";
import SupportTicketsPage from "./pages/CommunicationMGMT/SupportTickets";
import PlayersFormPage from "./pages/Profiles/Players/Form";
import SettingManagementPage from "./pages/SettingManagement";
import ReviewsPage from "./pages/ReviewManagement";
import TeamsFormPage from "./pages/WebDataManagement/MasterData/Teams/Form";
import PlatformFeePage from "@/pages/FinanceManagement/PlatformFees";
import GoToPage from "./pages/CommunicationMGMT/GoTo";
import ProductClassesPage from "./pages/WebDataManagement/MasterData/ProductClasses";
import MyTicketPage from "./pages/CommunicationMGMT/MyTicket";
import EventsPage from "./pages/WebDataManagement/MasterData/Events";
import EventsFormPage from "./pages/WebDataManagement/MasterData/Events/Form";
import MatrixStandardPage from "./pages/ShippingManagement/MatrixStandard";
import MatrixExpressPage from "./pages/ShippingManagement/MatrixExpress";
import PictureCategoriesPage from "./pages/JMInteractive/Pictures/PictureCategories";
import PicturePostedPage from "./pages/JMInteractive/Pictures/PicturePosted";
import AchievementBadgesPage from "./pages/JMInteractive/Achievements";
import SalesReportListPage from "./pages/SalesReport/SalesReportListPage";
import AuditLogsPage from "./pages/AuditLog";

function App() {
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state?.authReducer);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch all data using Promise.all
  const fetchAllData = async () => {
    if (!accessToken) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const [
        // [allTableColumnsResponse, isSuccessAllTableColumns],
        // [allTablesSelectedColumnsResponse, isSuccessAllTablesSelectedColumns],
        [responseData, isSuccessUserDetails],
      ] = await Promise.all([
        // Get({ route: `${allTablesColumnsApiEndPoint}`, accessToken }),
        // Get({ route: `${allTablesSelectedColumnsApiEndPoint}`, accessToken }),
        Get({ route: `${getLoginUserDetailsApiEndPoint}`, accessToken }),
      ]);

      // Process table columns
      // if (isSuccessAllTableColumns) {
      //   const columns = allTableColumnsResponse?.data?.data;
      //   dispatch(setWebUserColumns(columns?.["web-users"]?.fields || []));
      //   dispatch(setSubAdminColumns(columns?.["sub-admins"]?.fields || []));
      // }

      // if (isSuccessAllTablesSelectedColumns) {
      //   const selectedColumnsArray = allTablesSelectedColumnsResponse?.data?.data;
      //   const selectedColumns = selectedColumnsArray.reduce((acc, item) => {
      //     acc[item.page] = item?.columns;
      //     return acc;
      //   }, {});

      //   dispatch(setSelectedWebUserColumns(selectedColumns?.["web-users"] || []));
      //   dispatch(setSelectedSubAdminColumns(selectedColumns?.["sub-admins"] || []));
      // }

      // Process user details
      if (isSuccessUserDetails) {
        const userData = responseData?.data?.data?.user;
        dispatch(updateUser(userData));

        const allPermissions = userData?.roles?.flatMap((role) =>
          role?.permissions.map((item) => item?.name)
        );
        dispatch(setAllPermissions(allPermissions));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <>
      <ToastContainer />
      {isLoading && <Loader className={"mvh-100"} />}
      {!isLoading && (
        <BrowserRouter>
          <Routes>
            {/* ***************************** AUTHS *********************************/}
            <Route
              path="/"
              exact
              element={<BeforeLoginRoute element={<LoginPage />} />}
            />
            {/* ***************************** AUTHS **********************************/}
            <Route element={<ProtectedRouter />}>
              {/* ***************************** AFTER LOGIN *****************************/}
              <Route path="/dashboard" exact element={<DashboardPage />} />
              {/* **************************** USER MANAGMENT **************************/}
              <Route
                path="/user-management/admin-user-list"
                exact
                element={<AdminUserListPage />}
              />
              <Route
                path="/user-management/web-user-list"
                exact
                element={<WebUsersPage />}
              />
              {/* WEB USER DETAIL PAGE */}
              <Route
                // path="/user-management/web-user-detail/:slug"
                path="/user-management/web-user-list/:slug"
                exact
                element={<WebUserDetailPage />}
              />
              {/* WEB USER DETAIL PAGE */}
              <Route
                path="/user-management/user-Permissions"
                exact
                element={<RoleAndPermissions />}
              />
              {/* **************************** USER MANAGMENT **************************/}
              {/* **************************** PRODUCT MANAGEMENT **************************/}
              {/* **************************** MAPPING **************************/}
              <Route
                path="/web-data-management/mapping/base-product-product-group/jerseys"
                exact
                element={
                  <BaseProductProductGroupPage
                    productGroup={PRODUCT_GROUPS.JERSEYS}
                  />
                }
              />
              <Route
                path="/web-data-management/mapping/base-product-product-group/team-merchandise"
                exact
                element={
                  <BaseProductProductGroupPage
                    productGroup={PRODUCT_GROUPS.TEAM_MERCHANDISE}
                  />
                }
              />
              <Route
                path="/web-data-management/mapping/base-product-product-group/match-balls"
                exact
                element={
                  <BaseProductProductGroupPage
                    productGroup={PRODUCT_GROUPS.MATCH_BALLS}
                  />
                }
              />
              <Route
                path="/web-data-management/mapping/team-group-team"
                exact
                element={<TeamGroupTeamPage />}
              />
              <Route
                path="/web-data-management/mapping/competition-group-competition"
                exact
                element={<CompetitionGroupCompetitionPage />}
              />
              <Route
                path="/web-data-management/mapping/sport-group-category-product"
                exact
                element={<SportGroupCategoryProductPage />}
              />
              <Route
                path="/web-data-management/mapping/product-gender-size"
                exact
                element={<ProductGenderSizePage />}
              />
              <Route
                path="/web-data-management/mapping/product-brand"
                exact
                element={<ProductBrandPage />}
              />
              <Route
                path="/web-data-management/mapping/product-version"
                exact
                element={<ProductVersionPage />}
              />
              <Route
                path="/web-data-management/mapping/player-careers"
                exact
                element={<PlayerCareersPage />}
              />

              <Route
                path="/web-data-management/mapping/event-achievements"
                exact
                element={<EventParticipantsPage />}
              />

              {/* <Route
                path="/web-data-management/mapping/event-achievement"
                exact
                element={<TeamNotableAchievementsPage />}
              /> */}

              {/* **************************** MAPPING **************************/}
              {/* **************************** MASTER DATA **************************/}
              <Route
                path="/web-data-management/master-data/sports"
                exact
                element={<SportsPage />}
              />
              <Route
                path="/web-data-management/master-data/team-groups"
                exact
                element={<TeamGroupsPage />}
              />
              <Route
                path="/web-data-management/master-data/teams"
                exact
                element={<TeamsPage />}
              />
              <Route
                path="/web-data-management/master-data/teams/create"
                exact
                element={<TeamsFormPage />}
              />
              <Route
                path="/web-data-management/master-data/teams/:id/edit"
                exact
                element={<TeamsFormPage />}
              />
              <Route
                path="/web-data-management/master-data/players"
                exact
                element={<PlayersPage />}
              />
              <Route
                path="/web-data-management/master-data/players/create"
                exact
                element={<PlayersFormPage />}
              />

              <Route
                path="/web-data-management/master-data/players/:id/edit"
                exact
                element={<PlayersFormPage />}
              />

              <Route
                path="/web-data-management/master-data/player-types/lists"
                exact
                element={<PlayerTypesPage />}
              />
              <Route
                path="/web-data-management/master-data/competition-groups"
                exact
                element={<CompetitionGroupsPage />}
              />
              <Route
                path="/web-data-management/master-data/product-groups"
                exact
                element={<ProductGroupsPage />}
              />
              <Route
                path="/web-data-management/master-data/competitions"
                exact
                element={<CompetitionsPage />}
              />
              <Route
                path="/web-data-management/master-data/events"
                exact
                element={<EventsPage />}
              />
              <Route
                path="/web-data-management/master-data/events/create"
                exact
                element={<EventsFormPage />}
              />
              <Route
                path="/web-data-management/master-data/events/:id/edit"
                exact
                element={<EventsFormPage />}
              />
              <Route
                path="/web-data-management/master-data/brands"
                exact
                element={<BrandsPage />}
              />
              <Route
                path="/web-data-management/master-data/product-categories"
                exact
                element={<ProductCategoriesPage />}
              />
              <Route
                path="/web-data-management/master-data/products"
                exact
                element={<ProductsPage />}
              />
              <Route
                path="/web-data-management/master-data/product-classes"
                exact
                element={<ProductClassesPage />}
              />
              <Route
                path="/web-data-management/master-data/editions"
                exact
                element={<EditionsPage />}
              />
              <Route
                path="/web-data-management/master-data/terms"
                exact
                element={<TermsPage />}
              />
              <Route
                path="/web-data-management/master-data/versions"
                exact
                element={<VersionsPage />}
              />
              <Route
                path="/web-data-management/master-data/genders"
                exact
                element={<GendersPage />}
              />
              <Route
                path="/web-data-management/master-data/product-sizes"
                exact
                element={<ProductSizesPage />}
              />
              <Route
                path="/web-data-management/master-data/conditions"
                exact
                element={<ConditionsPage />}
              />
              <Route
                path="/web-data-management/master-data/materials"
                exact
                element={<MaterialsPage />}
              />
              {/* **************************** MASTER DATA **************************/}
              {/* **************************** PRODUCT MANAGEMENT **************************/}
              {/* Transaction MGMT */}
              <Route
                path="/transaction-management"
                exact
                element={<TransactionsPage />}
              />

              {/* Finance MGMT */}
              <Route
                path="/finance-management/platform-fees"
                exact
                element={<PlatformFeePage />}
              />
              <Route
                path="/finance-management/sales-report"
                exact
                element={<SalesReportListPage />}
              />

              {/* Review MGMT */}
              <Route
                path="/review-management"
                exact
                element={<ReviewsPage />}
              />

              {/* Currency MGMT */}
              <Route
                path="/currency-management/platform-currencies"
                exact
                element={<CurrenciesPage />}
              />
              <Route
                path="/currency-management/fx-rates"
                exact
                element={<FxRatesPage />}
              />

              {/* Language MGMT */}
              <Route
                path="/language-management/platform-languages"
                exact
                element={<LanguagesPage />}
              />
              <Route
                path="/language-management/translations-static"
                exact
                element={<TranslationsPage />}
              />

              {/* Country MGMT */}
              <Route
                path="/country-management"
                exact
                element={<CountriesPage />}
              />

              {/* Shipping MGMT */}
              <Route
                path="/shipping-management/matrix-standard"
                exact
                element={<MatrixStandardPage />}
              />
              <Route
                path="/shipping-management/matrix-express"
                exact
                element={<MatrixExpressPage />}
              />

              {/* ***************************** AFTER LOGIN *****************************/}
              <Route path="*" element={<AutoRedirect />} />

              {/* Content MGMT */}
              <Route
                path="/content-management/banners"
                exact
                element={<BannersPage />}
              />
              <Route
                path="/content-management/backgrounds"
                exact
                element={<BackgroundsPage />}
              />
              <Route
                path="/content-management/announcements"
                exact
                element={<AnnouncementsPage />}
              />

              {/* Profiles */}

              {/* Blog MGMT */}
              <Route
                path="/blog-management/blog-categories"
                exact
                element={<BlogCategoriesPage />}
              />
              <Route
                path="/blog-management/blog-posts"
                exact
                element={<BlogPostsPage />}
              />
              <Route
                path="/blog-management/blog-posts/create"
                exact
                element={<BlogPostsFormPage />}
              />
              <Route
                path="/blog-management/blog-posts/:id/edit"
                exact
                element={<BlogPostsFormPage />}
              />

              {/* JM Interactive MGMT */}
              {/* Achievement Badges MGMT */}
              <Route
                path="/jm-interactive-mgmt/achievement-badges"
                exact
                element={<AchievementBadgesPage />}
              />

              {/* Video MGMT */}
              <Route
                path="/jm-interactive-mgmt/videos/video-posted"
                exact
                element={<VideoPostedPage />}
              />
              <Route
                path="/jm-interactive-mgmt/videos/video-categories"
                exact
                element={<VideoCategoriesPage />}
              />

              {/* Picture MGMT */}
              <Route
                path="/jm-interactive-mgmt/pictures/picture-posted"
                exact
                element={<PicturePostedPage />}
              />
              <Route
                path="/jm-interactive-mgmt/pictures/picture-categories"
                exact
                element={<PictureCategoriesPage />}
              />

              {/* Settings */}
              <Route
                path="/settings"
                exact
                element={<SettingManagementPage />}
              />

              {/* Communication MGMT */}
              <Route
                path="/communication-management/support-tickets"
                exact
                element={<SupportTicketsPage />}
              />
              <Route
                path="/communication-management/my-tickets"
                exact
                element={<MyTicketPage />}
              />
              <Route
                path="/communication-management/support-tickets/:id/goto"
                exact
                element={<GoToPage />}
              />

              {/* Audit Log */}
              <Route path="/audit-logs" exact element={<AuditLogsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;

const AutoRedirect = () => {
  return <Navigate to={"/"} />;
};
